/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAnforderungListResponseDto } from '../../models/lexplus-anforderung-list-response-dto';
import { LexplusAnforderungStatusEnum } from '../../models/lexplus-anforderung-status-enum';
import { LexplusComplianceSortDirectionEnum } from '../../models/lexplus-compliance-sort-direction-enum';
import { LexplusComplianceSortEnum } from '../../models/lexplus-compliance-sort-enum';
import { LexplusErfuellungsgradEnum } from '../../models/lexplus-erfuellungsgrad-enum';

export interface ComplianceControllerGetArchivV1$Params {

/**
 * Matches the Artikel number, the description and the Erlass name.
 */
  search?: string;
  standortIDs?: Array<number>;
  themenbereichIDs?: Array<number>;

/**
 * All six grades are selectable. The bar draws four of them; NichtRelevant matches the requirements irrelevant at every Themenbereich, and NichtDefiniert those carrying at least one Themenbereich left undefined.
 */
  erfuellungsgrade?: Array<LexplusErfuellungsgradEnum>;

/**
 * Only Neu, NeueVersion and Bestehend can match outside the Archiv scope, which holds Ersetzt and Entfernt. Unveraendert, AlteVersion and ZuPruefen belong to a Neosys-internal comparison and are never stored, so they match nothing.
 */
  status?: Array<LexplusAnforderungStatusEnum>;
  herausgeberIDs?: Array<number>;
  rechtsbereichIDs?: Array<number>;

/**
 * The kind of Erlass — Gesetz, Verordnung, Reglement, Merkblatt, Checkliste. Matches nothing on the firmenintern scope, whose requirements belong to no Erlass.
 */
  erlasstypIDs?: Array<number>;
  nachweispflicht?: boolean;
  bewilligungspflicht?: boolean;

/**
 * Whether the requirement applies to the company itself rather than to one of its Standorte. Omitted means «either».
 */
  betrifftUnternehmen?: boolean;

/**
 * Upper bound on Inkrafttretung, as an ISO 8601 date.
 */
  inkrafttretenBis?: string;

/**
 * Responsible Funktionen. Responsibility is assigned to a Funktion; `verantwortlichePersonIDs` selects by person.
 */
  verantwortlicheFunktionIDs?: Array<number>;

/**
 * Responsible people, by user id. A person stands for the Funktionen they hold, so this widens `verantwortlicheFunktionIDs` by those Funktionen rather than narrowing it, as on the Aufgaben list. A person holding no Funktion matches nothing.
 */
  verantwortlichePersonIDs?: Array<string>;

/**
 * Include the requirements nobody is responsible for, matching the «nicht zugewiesen» filter option. Added to the Funktionen selected alongside it rather than replacing them, as on the Aufgaben list. Nobody is responsible means no Themenbereich of the requirement names a Funktion a person of the tenant holds, so a Funktion without holders counts as unassigned. On the firmenintern scope, the Funktion stored for the requirement at the row's Standort.
 */
  verantwortlichNichtZugewiesen?: boolean;

/**
 * Tag ids, not names. Matches an object carrying at least one of them.
 */
  tags?: Array<string>;
  sortBy?: LexplusComplianceSortEnum;
  sortDirection?: LexplusComplianceSortDirectionEnum;
  page?: number;
  limit?: number;
}

export function complianceControllerGetArchivV1(http: HttpClient, rootUrl: string, params?: ComplianceControllerGetArchivV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusAnforderungListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, complianceControllerGetArchivV1.PATH, 'get');
  if (params) {
    rb.query('search', params.search, {});
    rb.query('standortIDs', params.standortIDs, {});
    rb.query('themenbereichIDs', params.themenbereichIDs, {});
    rb.query('erfuellungsgrade', params.erfuellungsgrade, {});
    rb.query('status', params.status, {});
    rb.query('herausgeberIDs', params.herausgeberIDs, {});
    rb.query('rechtsbereichIDs', params.rechtsbereichIDs, {});
    rb.query('erlasstypIDs', params.erlasstypIDs, {});
    rb.query('nachweispflicht', params.nachweispflicht, {});
    rb.query('bewilligungspflicht', params.bewilligungspflicht, {});
    rb.query('betrifftUnternehmen', params.betrifftUnternehmen, {});
    rb.query('inkrafttretenBis', params.inkrafttretenBis, {});
    rb.query('verantwortlicheFunktionIDs', params.verantwortlicheFunktionIDs, {});
    rb.query('verantwortlichePersonIDs', params.verantwortlichePersonIDs, {});
    rb.query('verantwortlichNichtZugewiesen', params.verantwortlichNichtZugewiesen, {});
    rb.query('tags', params.tags, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusAnforderungListResponseDto>;
    })
  );
}

complianceControllerGetArchivV1.PATH = '/v1/compliance/archiv';
